"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schrader Dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineApi = exports.MachineApiFactory = exports.MachineApiFp = exports.MachineApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * MachineApi - axios parameter creator
 * @export
 */
var MachineApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a new machine
         * @param {number} locationId The location id of the machine(s)
         * @param {Machine} machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMachine: function (locationId, machine, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'locationId' is not null or undefined
                            (0, common_1.assertParamExists)('addMachine', 'locationId', locationId);
                            // verify required parameter 'machine' is not null or undefined
                            (0, common_1.assertParamExists)('addMachine', 'machine', machine);
                            localVarPath = "/locations/{locationId}/machines"
                                .replace("{".concat("locationId", "}"), encodeURIComponent(String(locationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(machine, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMachine: function (machineId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'machineId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteMachine', 'machineId', machineId);
                            localVarPath = "/machines/{machineId}"
                                .replace("{".concat("machineId", "}"), encodeURIComponent(String(machineId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachine: function (machineId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'machineId' is not null or undefined
                            (0, common_1.assertParamExists)('getMachine', 'machineId', machineId);
                            localVarPath = "/machines/{machineId}"
                                .replace("{".concat("machineId", "}"), encodeURIComponent(String(machineId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary list machines at location
         * @param {number} locationId The location id of the machine(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachinesByLocation: function (locationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'locationId' is not null or undefined
                            (0, common_1.assertParamExists)('getMachinesByLocation', 'locationId', locationId);
                            localVarPath = "/locations/{locationId}/machines"
                                .replace("{".concat("locationId", "}"), encodeURIComponent(String(locationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a machine
         * @param {number} machineId The id of the machine
         * @param {Machine} machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMachine: function (machineId, machine, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'machineId' is not null or undefined
                            (0, common_1.assertParamExists)('updateMachine', 'machineId', machineId);
                            // verify required parameter 'machine' is not null or undefined
                            (0, common_1.assertParamExists)('updateMachine', 'machine', machine);
                            localVarPath = "/machines/{machineId}"
                                .replace("{".concat("machineId", "}"), encodeURIComponent(String(machineId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(machine, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MachineApiAxiosParamCreator = MachineApiAxiosParamCreator;
/**
 * MachineApi - functional programming interface
 * @export
 */
var MachineApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MachineApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a new machine
         * @param {number} locationId The location id of the machine(s)
         * @param {Machine} machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMachine: function (locationId, machine, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addMachine(locationId, machine, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMachine: function (machineId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteMachine(machineId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachine: function (machineId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMachine(machineId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary list machines at location
         * @param {number} locationId The location id of the machine(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachinesByLocation: function (locationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMachinesByLocation(locationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a machine
         * @param {number} machineId The id of the machine
         * @param {Machine} machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMachine: function (machineId, machine, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMachine(machineId, machine, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MachineApiFp = MachineApiFp;
/**
 * MachineApi - factory interface
 * @export
 */
var MachineApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MachineApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a new machine
         * @param {number} locationId The location id of the machine(s)
         * @param {Machine} machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMachine: function (locationId, machine, options) {
            return localVarFp.addMachine(locationId, machine, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMachine: function (machineId, options) {
            return localVarFp.deleteMachine(machineId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachine: function (machineId, options) {
            return localVarFp.getMachine(machineId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary list machines at location
         * @param {number} locationId The location id of the machine(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachinesByLocation: function (locationId, options) {
            return localVarFp.getMachinesByLocation(locationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a machine
         * @param {number} machineId The id of the machine
         * @param {Machine} machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMachine: function (machineId, machine, options) {
            return localVarFp.updateMachine(machineId, machine, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MachineApiFactory = MachineApiFactory;
/**
 * MachineApi - object-oriented interface
 * @export
 * @class MachineApi
 * @extends {BaseAPI}
 */
var MachineApi = /** @class */ (function (_super) {
    __extends(MachineApi, _super);
    function MachineApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a new machine
     * @param {number} locationId The location id of the machine(s)
     * @param {Machine} machine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    MachineApi.prototype.addMachine = function (locationId, machine, options) {
        var _this = this;
        return (0, exports.MachineApiFp)(this.configuration).addMachine(locationId, machine, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a machine
     * @param {number} machineId The id of the machine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    MachineApi.prototype.deleteMachine = function (machineId, options) {
        var _this = this;
        return (0, exports.MachineApiFp)(this.configuration).deleteMachine(machineId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a machine
     * @param {number} machineId The id of the machine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    MachineApi.prototype.getMachine = function (machineId, options) {
        var _this = this;
        return (0, exports.MachineApiFp)(this.configuration).getMachine(machineId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary list machines at location
     * @param {number} locationId The location id of the machine(s)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    MachineApi.prototype.getMachinesByLocation = function (locationId, options) {
        var _this = this;
        return (0, exports.MachineApiFp)(this.configuration).getMachinesByLocation(locationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a machine
     * @param {number} machineId The id of the machine
     * @param {Machine} machine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    MachineApi.prototype.updateMachine = function (machineId, machine, options) {
        var _this = this;
        return (0, exports.MachineApiFp)(this.configuration).updateMachine(machineId, machine, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MachineApi;
}(base_1.BaseAPI));
exports.MachineApi = MachineApi;
